import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { FlatButton, Popover } from 'material-ui'
import AiMagic from '../../../../../assets/AiMagic'
import { generateAIResponse, clearGeneratedText } from '../../../../../../state/actions/ai-assistant'
import AIAssistantPopoverContent from '../AIAssistantPopoverContent'
import classnames from 'classnames/bind'
import css from '../../styles.css'

const cx = classnames.bind(css)
class AIAssistantButton extends Component {
  static propTypes = {
    editorState: PropTypes.object.isRequired,
    updateParentBodyState: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    error: PropTypes.string,
    generatedText: PropTypes.string,
    messages: PropTypes.arrayOf(PropTypes.object).isRequired,
    clearGeneratedText: PropTypes.func.isRequired,
  }

  state = {
    popoverOpen: false,
    anchorEl: null,
  }

  
  handleClick = (event) => {
    event.preventDefault()
    this.setState({
      popoverOpen: true,
      anchorEl: event.currentTarget,
    })
  }

  handleRequestClose = () => {
    this.setState({
      popoverOpen: false,
    })
  }

  handleGenerate = (prompt, tone) => {
    const { messages, generateAIResponse, clearGeneratedText } = this.props
    
    clearGeneratedText()
    try {
      // Create conversation context object
      const conversationContext = messages ? { id: messages } : null
      
      generateAIResponse(conversationContext, prompt, tone)
    } catch (error) {
      console.error('Failed to fetch AI response:', error)
    }
  }

  handleAccept = () => {
    const { generatedText, editorState, updateParentBodyState, clearGeneratedText } = this.props
    
    // Import what you need from draft-js
    const { Modifier, EditorState } = require('draft-js')
    
    // Insert the generated text at the current cursor position
    const contentState = editorState.getCurrentContent()
    const selectionState = editorState.getSelection()
    
    const newContentState = Modifier.insertText(
      contentState,
      selectionState,
      generatedText
    )
    
    // Create a new editor state with the updated content
    const newEditorState = EditorState.push(
      editorState,
      newContentState,
      'insert-characters'
    )
    
    // Update the parent component's editor state
    updateParentBodyState(newEditorState)
    
    // Reset the generated text
    clearGeneratedText()
    
    // Close the popover
    this.handleRequestClose()
  }

  render() {
    const buttonWrapper = cx(css.buttonWrapper)
    const buttonStyle = cx(css.openOptionsButton)
    const popover = cx(css.popover)
    const { popoverOpen, anchorEl } = this.state
    const { loading, error, generatedText } = this.props
    
    return (
      <div>
        <div className={buttonWrapper}>
          <button onClick={this.handleClick} className={buttonStyle}>
            <AiMagic />
          </button>
        </div>
        
        <Popover
          open={popoverOpen}
          anchorEl={anchorEl}
          anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
          targetOrigin={{horizontal: 'left', vertical: 'top'}}
          onRequestClose={this.handleRequestClose}
        >
          <div className={popover}>
            <AIAssistantPopoverContent
              loading={loading}
              error={error}
              generatedText={generatedText}
              onAccept={this.handleAccept}
              onReject={this.handleRequestClose}
              onClose={this.handleRequestClose}
              onGenerate={this.handleGenerate}
            />
          </div>
        </Popover>
      </div>
    )
  }
}

// Redux connection
const mapStateToProps = (state) => ({
  loading: state.aiAssistant.loading,
  error: state.aiAssistant.error,
  generatedText: state.aiAssistant.generatedText,
})

const mapDispatchToProps = (dispatch) => bindActionCreators({
  generateAIResponse,
  clearGeneratedText,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(AIAssistantButton) 



// WEBPACK FOOTER //
// ./src/components/sitewide/RichTextEditor/StyleControls/AIAssistant/AIAssistantButton/index.js